import React from 'react';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddressComponent from '../../AddressComponent/AddressComponent';

export default function CheckoutAddressComponent(props) {

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

    const componentProps = {
        ...props.componentProps
    }
  return (
    <Grid container spacing={3}>
        <Grid item xs={1} lg={1} md={1}>
            <FormControlLabel value={props.element.addressSha} control={<Radio color="secondary" />} />
        </Grid>
        <Grid item xs={11} lg={11} md={11}>
            <AddressComponent editAddress={true} element={props.element} componentConstants={componentConstants} componentMethods={componentMethods} componentProps={componentProps} />
        </Grid>
    </Grid>
  );
}